// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ProductCategoryListResultModel from '../../model/product-category-list-result-model';
import ProductCategoryListResultDTO from '../dto/product-category-list-result-dto';
import ProductCategoryModel from '../../model/product-category-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ProductCategoryListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ProductCategoryListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ProductCategoryModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  'items'?: ProductCategoryModel[];
  /**
  */
  'links'?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<ProductCategoryListResultDTO>): ProductCategoryListResultModel;
  static toModel(dto: DeepPartial<ProductCategoryListResultDTO> | undefined | null): ProductCategoryListResultModel | undefined;
  static toModel(dto: DeepPartial<ProductCategoryListResultDTO> | undefined | null): ProductCategoryListResultModel | undefined {
    return dto ? new ProductCategoryListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ProductCategoryListResultModel> | ProductCategoryListResultModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'items': unwrapped.items,
      'links': unwrapped.links,
    } as ProductCategoryListResultDTO;
  }
}
